import { render, staticRenderFns } from "./MadeByComponent.vue?vue&type=template&id=a08941a2"
import script from "./MadeByComponent.vue?vue&type=script&lang=js"
export * from "./MadeByComponent.vue?vue&type=script&lang=js"
import style0 from "./MadeByComponent.vue?vue&type=style&index=0&id=a08941a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports